import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { headerProductWatcher } from '@/model/header/kraken';

export const watchHeaderProductNavigationActions = () =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'VIEW_HEADER_PRODUCT_EVENT_CALLED';
        data:
          | object
          | {
              label: string;
              link: {
                url: string;
              };
            };
      }>
    ) => await headerProductWatcher({ callback })
  );
